module.exports = __webpack_public_path__ + "img/alert0_v2.72fafb5c.svg";